import { useNavigate } from "@remix-run/react";
import { ArrowRight } from "lucide-react";
import { Button } from "~/components/ui/button";

export default function UseCaseSection2() {
  const navigate = useNavigate();

  return (
    <section className="relative flex w-full sm:h-[575px]">
      <div className="container flex flex-col items-center gap-12 sm:items-end sm:justify-center">
        <div className="flex max-w-[450px] flex-col gap-8 sm:w-1/2 sm:pl-12">
          <div className="flex flex-col gap-2">
            <h2 className="font-recursive text-4xl font-bold">
              A better experience for your users
            </h2>
            <p className="text-pretty">
              Provide a familiar, user-friendly interface that will make your
              team's transition to digital data management seamless. Increase
              user adoption and satisfaction of your Knack app.
            </p>
          </div>
          <Button
            className="h-fit w-fit px-8 py-3 text-lg font-semibold leading-normal"
            onClick={() => navigate("/login?try")}
          >
            Try now <ArrowRight className="ml-1 h-6 w-6" />
          </Button>
        </div>
        <img
          src="https://utfs.io/f/dcYEW17H8PtSckk2yOmzU67Fqeipzs4bSJdDQoKk2Wg5xGYa"
          alt=""
          className="relative top-0 block h-full w-full rounded bg-emerald-400 sm:hidden"
        />
        <img
          src="https://utfs.io/f/dcYEW17H8PtSWkkxMgsrXNJB2K9dfosZOiqRzyEt3bx5UPGM"
          alt=""
          className="relative left-0 top-0 hidden h-[540px] w-full rounded bg-emerald-400 sm:absolute sm:block sm:min-h-[540px] sm:w-1/2 sm:rounded-l-none"
        />
      </div>
    </section>
  );
}
